import { Pipe, PipeTransform } from '@angular/core';
import { POSITIVE_SHORTAGE_STATUSES } from 'src/app/defaults/product.defaults';
import { ShortageStatus } from 'src/app/entities/products/enums/shortage-status.enum';

@Pipe({
  standalone: true,
  name: 'shortageStatusAvailability',
})
export class ShortageStatusAvailabilityPipe implements PipeTransform {
  /**
   * Returns true if the availability of the shortage is one of the "positive" statuses
   *
   * @param shortageStatus
   */
  transform(shortageStatus: ShortageStatus): boolean {
    if (!shortageStatus) return false;

    return POSITIVE_SHORTAGE_STATUSES.includes(shortageStatus);
  }
}
